/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [vp.InteracTransactionResponse, (transactionID: string) => void, () => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchInteracMoneyRequestTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.InteracTransactionResponse>({
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    FailureReason: '',
    TransactionDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    LastModified: '',
    Name: '',
    Email: '',
    PhoneNumber: '',
    RecipientName: '',
    MessageForRecipient: '',
    ClientReferenceNumber: '',
    ConfirmationNumber: '',
    ProcessingDate: '',
    BatchFileName: '',
    Notes: '',
    TransactionTypeCode: '',
    GLCode: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);

      const res = await api.fetchInteracMoneyRequestTransaction({ TransactionID: requestParams }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        FailureReason: '',
        TransactionDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        LastModified: '',
        Name: '',
        Email: '',
        PhoneNumber: '',
        RecipientName: '',
        MessageForRecipient: '',
        ClientReferenceNumber: '',
        ConfirmationNumber: '',
        ProcessingDate: '',
        BatchFileName: '',
        Notes: '',
        TransactionTypeCode: '',
        GLCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchInteracMoneyRequestTransaction);
